import React, {useContext} from 'react';
import {AppContext} from '../contexts/AppContext';
import AccommodationTeaser from './Common/AccommodationTeaser';
import {getBookingUrl, getDetailPageUrl} from '../helpers/accommodation';
import {translate} from '../helpers/base';

const PoiOverlay = ({poi}) => {

    const {selectedFilters, setCurrentMapPoi, locale} = useContext(AppContext);
    const {bookable, detailPageUrl, kognitivId, trackingParams} = poi;

    return (
        <div className="page--overlay--inner map-poi--overlay--inner js-aa4y-single-enquiry" data-aa4y-kognitiv-id={kognitivId}>
            <div className="page--overlay--header area--text">
                <span className="lead">{translate('accommodation-overview.poiOverlay.header')}</span>
                <label className="page--overlay--close" onClick={() => setCurrentMapPoi(null)}></label>
            </div>
            <div className="page--overlay--content">
                <AccommodationTeaser data={poi} hideButtons={true} />
            </div>
            <div className="page--overlay--bottom-btns">
                <a href={getDetailPageUrl(detailPageUrl, selectedFilters)} className="btn btn-outline btn-sm">
                    {translate('accommodation-overview.accommodation.more')}
                </a>
                {bookable ?
                    <a href={getBookingUrl(kognitivId, trackingParams, selectedFilters, locale)} target="_blank" className="btn btn-primary btn-sm" rel="noreferrer">
                        {translate('accommodation-overview.accommodation.book')}
                    </a> :
                    <button type="button" className="btn btn-primary btn-sm js-aa4y-single-enquiry__btn">
                        {translate('accommodation-overview.accommodation.inquire')}
                    </button>
                }
            </div>
        </div>
    );
};

export default PoiOverlay;
